import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=b076624a&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b076624a')) {
      api.createRecord('b076624a', component.options)
    } else {
      api.reload('b076624a', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=b076624a&", function () {
      api.rerender('b076624a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/purchase-order/IndexPage.vue"
export default component.exports